// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__26j0a","savePackageButton":"ClientWallet_savePackageButton__3bc01"};